'use strict';
'use es6';

var _app = require('./app');

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _app2.default().init();


//////////////////
// WEBPACK FOOTER
// ./js/start.js
// module id = 238
// module chunks = 0